import 'jquery.appear';

export function animate() {
	function initPageAnim() {
		var windowW = $(window).width();
		if (windowW >= 768) {
			$("body").find(".animated").appear(
				function () {
					var element = $(this);
					var animation = element.data("animation");
					var animationDelay = element.data("delay");

					if (animationDelay) {
						setTimeout(function () {
							element.addClass(animation);
							element.removeClass("hiding");
						}, animationDelay);
					} else {
						element.addClass(animation);
						element.removeClass("hiding");
					}
				}, { accY: -50 }
			);
		} else {
			$('.hiding').removeClass('hiding');
		}
	}

	$(window).on("load", function(){
	    initPageAnim();
	});
}

